import { Component } from 'react';

class Button extends Component {
  render() {
    return this.props.children;
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Dropdown/Button/index.js